import API from 'app/utils/apiClient';
import { toParams } from 'app/utils/url';

const getRecommendations = (page, perPage = 20) => {
  const params = toParams({ page, perPage }, true);
  return API.get(`/recommended-stories/${params}`);
};

// elastic search
const searchAll = (q) => {
  const params = toParams({ q }, true);
  return API.get(`/search/all/${params}`);
};

const searchStories = (q, lastEvaluatedKey) => {
  const params = toParams({ q, lastEvaluatedKey }, true);
  return API.get(`/search/story/${params}`);
};

const searchUsers = (q, lastEvaluatedKey) => {
  const params = toParams({ q, lastEvaluatedKey }, true);
  return API.get(`/search/user/${params}`);
};

const searchTags = (q, lastEvaluatedKey, withProtected = true) => {
  const params = toParams({ q, lastEvaluatedKey, withProtected }, true);
  return API.get(`/search/tag/${params}`);
};

export default {
  getRecommendations,
  searchAll,
  searchStories,
  searchTags,
  searchUsers,
  searchTags,
};



// WEBPACK FOOTER //
// ./src/app/apis/search.js